export const SITE = {
  name: 'PANOZ4U',
  tagline: "THERE'S ALWAYS A SOLUTION.",
  url: 'https://panoz4u.com',
  telegram: { handle: '@panoz4ever', url: 'https://t.me/panoz4ever' },
  email: 'panoz@panoz.it',
  socials: [
    { id: 'youtube', label: 'YouTube', url: 'https://www.youtube.com/@panoz4u' },
    { id: 'instagram', label: 'Instagram', url: 'https://www.instagram.com/panoz4u' },
    { id: 'tiktok', label: 'TikTok', url: 'https://www.tiktok.com/@panoz4u' },
    { id: 'facebook', label: 'Facebook', url: 'https://www.facebook.com/panoz4u' },
    { id: 'linkedin', label: 'LinkedIn', url: 'https://www.linkedin.com/in/panoz/' },
  ],
  videos: {
    stories: [
      {
        id: 'To7-RsM5LOA',
        title: 'I segreti di una scatola. Un viaggio nel tempo a Cardiff, ancora Juve e Real Madrid',
      },
      {
        id: 'pLIVnW7fhIE',
        title: 'I segreti comunicativi del Professore della Casa di carta — Docere, Movere, Delectare',
      },
    ],
    words: [
      { id: 'KPHKh8ZI7PQ', title: 'Il best of dei disastri comunicativi di Motta' },
      { id: 'sIhn2PY5lJc', title: "L'errore che ti distrugge in ogni confronto (non farlo MAI)" },
    ],
  },
  press: { label: 'Forbes Italia', year: '2018', url: 'https://forbes.it/2018/03/11/un-videogioco-scoprira-il-nuovo-messi/' },
};
